import { Box, Skeleton, Stack } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { VendorOpportunity } from 'modules/vendorOpportunity';
import { InsuranceStepper } from './insuranceStepper';
import { CoverageStatus } from './CoverageStatus';
import { InsuranceHeader } from './InsuranceHeader';
import { InsuranceAccordion } from './insuranceAccordion';
import { useFetchInsuranceData } from '../hooks/useFetchInsuranceData';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { insuranceActions } from '../model';

interface Props {
  creditApp: any;
  vo: VendorOpportunity;
}

export const InsuranceTab = ({ vo, creditApp }: Props) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { isFetching } = useFetchInsuranceData(vo, creditApp);

  useEffect(
    () => () => {
      dispatch(insuranceActions.clearState());
    },
    [dispatch]
  );

  return (
    <Box className={classes.root}>
      {!isFetching ? (
        <Stack gap="1rem">
          <InsuranceStepper />
          <InsuranceHeader />
          <CoverageStatus />
          <InsuranceAccordion />
        </Stack>
      ) : (
        <Skeleton variant="rectangular" height="300px" width="100%" />
      )}
    </Box>
  );
};

const useStyles = makeStyles({
  root: {
    backgroundColor: 'white',
    padding: '24px',
    color: '#000000de',
  },
});
